export const IconEdit = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
			<path
				fill="currentColor"
				d="M9.63172798,-0.403805922 C11.2885822,-0.403805922 12.631728,0.939339828 12.631728,2.59619408 L12.630728,13.0101941 L12.631728,15.0104076 L12.630728,15.0101941 L12.631728,17.8388348 L9.63172798,20.8388348 L6.63172798,17.8388348 L6.63172798,2.59619408 C6.63172798,0.939339828 7.97487373,-0.403805922 9.63172798,-0.403805922 Z M10.630728,15.0101941 L8.63072798,15.0101941 L8.63172798,17.0104076 L9.63172798,18.0104076 L10.631728,17.0104076 L10.630728,15.0101941 Z M9.63172798,1.59619408 C9.07944323,1.59619408 8.63172798,2.04390933 8.63172798,2.59619408 L8.63072798,13.0101941 L10.630728,13.0101941 L10.631728,2.59619408 C10.631728,2.04390933 10.1840127,1.59619408 9.63172798,1.59619408 Z"
				transform="rotate(45 9.632 10.218)"
			/>
		</svg>
	);
};
